<template>
<div>
    <Modal v-model="$parent.manageterritoryListDialog" width="1000"
           title="Manage Territory" :mask-closable="false">
        <div>
            <Row>
             <Col span="8">
                 <city @city="selectedCity=$event" ref="city-form"></city>
             </Col>
             <Col span="1" style="padding-left: 11px">
                 <Divider  type="vertical" style="height: 50vh"></Divider>
             </Col>
             <Col span="6">
                 <area-group :city="selectedCity" @areaGroup="selectedAreaGroup=$event"
                             ref="area-group-form"></area-group>
             </Col>
             <Col span="1" style="padding-left: 11px">
                 <Divider  type="vertical" style="height: 50vh"></Divider>
             </Col>
             <Col span="8">
                 <area-cmp :city="selectedCity" :areaGroup="selectedAreaGroup"></area-cmp>
             </Col>
            </Row>

        </div>
        <div slot="footer">
            <Button style="background: #999999; color: white;font-weight: bolder" @click="onCloseManageTerritoryDialog">CLOSE</Button>
        </div>
    </Modal>
</div>
</template>

<script>
import City from './City'
import Area from './Area'
import AreaGroup from './AreaGroup'
    export default {
        name: "ManageTerritory",
        components:{City, 'area-cmp': Area, AreaGroup},
        data: function(){
            return{
                selectedCity: {id: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a'},
                selectedAreaGroup: {id: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a'}
            }
        },
        methods: {
            onCloseManageTerritoryDialog(){
                this.$refs['city-form'].$refs['cityTable'].clearCurrentRow();             //clear Highlighted rows
                this.$refs['area-group-form'].$refs['areaGroupTable'].clearCurrentRow();  //clear Highlighted rows
                this.selectedCity = {id: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a'};
                this.selectedAreaGroup = {id: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a'};
                this.$parent.manageterritoryListDialog=false
            }
        }
    }
</script>

<style scoped>
/deep/ .ivu-table td {
    border-bottom: 0px;
    font-size: 14px;
}
/deep/ .ivu-table th {
    border-bottom: 0px;
    font-size: 14px;
    text-align: center;
}
/deep/ .ivu-table-wrapper {
    position: unset !important;
    border: 0px ;
}
/deep/ .ivu-table-cell {
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
}
/deep/ .ivu-table:before{
    background: none;
}
/deep/ .ivu-table:after{
    background: none;
}
</style>